import { useState } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { getCountsQueryKey, getRequestsQueryKey, useDeleteRequest } from "@synthesis/shared-services/external/application/hooks";
import { setPromiseSnack } from "@synthesis/shared-ui";

import { SNACK_TITLES_DELETE_DRAFT } from "../create-application-page.lib";

/** Удаление черновика заявки (external, soft-delete, только статус DRAFT). */
export const useDeleteApplicationDraft = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const deleteRequestMutation = useDeleteRequest<unknown>();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteDraft = (draftId: string) => {
    if (isDeleting) {
      return;
    }

    setIsDeleting(true);

    const promise = deleteRequestMutation
      .mutateAsync({ path: { id: draftId } })
      .then(async () => {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: getRequestsQueryKey() }),
          queryClient.invalidateQueries({ queryKey: getCountsQueryKey() }),
        ]);
        navigate({ to: "/" });
      })
      .finally(() => {
        setIsDeleting(false);
      });

    setPromiseSnack({
      promise,
      promiseSettings: {
        title: SNACK_TITLES_DELETE_DRAFT,
      },
    });
  };

  return {
    deleteDraft,
    isDeleting: isDeleting || deleteRequestMutation.isPending,
  };
};
